import React from "react";
import styled from "styled-components";
import { EyeIcon } from "./assets";
import { useNavigate } from "react-router-dom";

const Card = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: "Arial", sans-serif;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
`;

const Label = styled.span`
  color: var(--Color-Text-Gray, #64748b);
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.14px;
`;

const Value = styled.span`
color: var(--Color-Brand-Primary, #212543);
font-family: Montserrat;
font-size: var(--Fonts-P3, 14px);
font-style: normal;
font-weight: 500;
line-height: 160%; /* 22.4px */
letter-spacing: -0.14px;
max-width: 50%;  /* Enable wrapping */
  word-break: break-word;
  white-space: normal;
  text-align: right;
`;

const StatusBadge = styled.span`
  background: ${(props) =>
    props.status === "Unsuccessful" ? "#fde2e2" : "#e2fdeb"};
  color: ${(props) =>
    props.status === "Unsuccessful" ? "#e63946" : "#2a9d8f"};
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: bold;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #E1E4EA;
  margin: 6px 0;
`;

const ActionIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #666;
  cursor: pointer;
  font-size: 18px;
`;
const StatusTag = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  align-self: stretch;
  background: ${(props) => {
    switch (props.status) {
      case "successful":
        return "linear-gradient(-90deg, rgba(18, 124, 78, 0.1), rgba(18, 124, 78, 0.1))";
      case "pending":
        return "linear-gradient(-90deg, rgba(244, 186, 52, 0.1), rgba(244, 186, 52, 0.1))";
      case "tracking":
        return "linear-gradient(-90deg, rgba(244, 186, 52, 0.1), rgba(244, 186, 52, 0.1))";
      case "unsuccessful":
        return "linear-gradient(-90deg, rgba(240, 70, 63, 0.1), rgba(240, 70, 63, 0.1))";
      case "paid":
        return "rgba(89, 84, 222, 0.1)";
      default:
        return "transparent";
    }
  }};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 4px 8px;
  flex-shrink: 0;
`;

const StatusText = styled.span`
  color: ${(props) => {
    switch (props.status) {
      case "successful":
        return "rgb(18, 124, 78)";
      case "pending":
        return "rgb(244, 186, 52)";
      case "tracking":
        return "rgb(244, 186, 52)";
      case "unsuccessful":
        return "rgb(240, 70, 63)";
      case "paid":
        return "rgba(89, 84, 222, 1)";
      default:
        return "inherit";
    }
  }};
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;
function ReferralCard({item }) {
  const status = item?.status.toLowerCase();
  const navigate = useNavigate();
  
  const onViewReason = (item) => {
    navigate(`/myreferrals/${item._id}`, { state: { referral: item } });
  };
  return (
    <Card>
      <Row>
        <Label>Date</Label>
        <Value>{item?.date}</Value>
      </Row>
      <Row>
        <Label>Company Website</Label>
        <Value>{ item?.company_website_url}</Value>
      </Row>
      <Row>
        <Label>Vendor</Label>
        <Value>{item.vendor_name}</Value>
      </Row>
      <Row>
        <Label>Status</Label>
        <StatusTag status={status}>
          <StatusText status={status}>{status}</StatusText>
        </StatusTag>
      </Row>
      <Row>
        <Label>Reward</Label>
        <Value>{item.vendor_reward}</Value>
      </Row>
      <Divider />
      <Row>
        <Label>Actions</Label>
        <ActionIcon  onClick={(e) => {
            e.stopPropagation(); // prevent triggering row click
            onViewReason(item);
          }}>
          <img src={EyeIcon} alt="Eye" size={20} />
        </ActionIcon>
      </Row>
    </Card>
  );
}

export default ReferralCard;
